import React from 'react'
import { Box } from 'reactjs-admin-lte'
import { Button, Row, Col, FormGroup, FormControl, ControlLabel, ButtonToolbar } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import '../../report/report.css'
import moment from 'moment'
import Select from 'react-select'
import DatePicker from '../../../component/element/DatePicker'
import CkTimePicker from '../../../component/element/CkTimePicker'
import TextFieldModal from '../../../component/element/TextFieldModal'
import { momentHelper } from '../../../utils/helpers'
import WorkJobAssignTaskModal from '../jobcontrol/WorkJobAssignTaskModal'
import WorkdocStore from '../../../stores/WorkdocStore'
import JobControlBoardTable from '../jobcontrol/JobControlBoardTable'
import IframeModal from '../../../component/element/IframeModal'
import EmployeeModal from '../../hr/EmployeeModal'
import $ from 'jquery';
// import 'rc-time-picker/assets/index.css'
// import TimePicker from 'rc-time-picker'
// import { Form, FormControl, FormGroup, InputGroup, Glyphicon } from 'react-bootstrap'
var NotificationSystem = require('react-notification-system');

const mockData = {
  bf_task_id: '',
  taskName: '',
  taskValue: '',
  technicianName: '',
  startTime: {
    date: '',
    time: ''
  },
  finishTime: {
    date: '',
    time: ''
  },
  duration: '',
  wageAmount: '',
  taskStatus: '-1',
  inspector: '',
  remark:'',
  assignTask: { person: { contractor_id: '', employee_id: '' }, leader: { employee_id: '' } }
}
const jobList = ["รื้อ", "เคาะ", "โป๊ะ", "พื้น", "ผสมสี", "พ่น", "ประกอบ", "ขัดสี", "ล้าง", "QC"]
const taskOptions = [{ label: 'รื้อ', value: 'dismanlingState' },
{ label: 'เคาะ', value: 'hitState' },
{ label: 'โป๊ว', value: 'trapState' },
{ label: 'พื้น', value: 'groundState' },
{ label: 'ผสมสี', value: 'mixColorState' },
{ label: 'พ่น', value: 'paintState' },
{ label: 'ประกอบ', value: 'assemblyState' },
{ label: 'ขัดสี', value: 'polishState' },
{ label: 'ล้าง', value: 'cleanState' },
{ label: 'QC', value: 'qcState' }]



export default class RecheckTimeTable extends React.Component {
  constructor(props) {
    super(props)
    moment.locale('th')
    this.headerTitles = {
      taskName: 'รายการ',
      technicianName: 'พนักงาน',
      startTime: 'เวลาเริ่ม',
      finishTime: 'เวลาเสร็จ',      
      ackTime:'กดรับงาน',
      expectDuration: 'กำหนดเสร็จ', 
      duration: 'ใช้เวลาจริง',     
      taskStatus: 'สถานะ',
      // inspector: 'ผู้ตรวจงาน',
      remark :'หมายเหตุ'
    }

    this.headerWidth = {
      startTime: ''
    }

    const mockDataArr = taskOptions.map((item, index) => {
      let jsonObj = JSON.parse(JSON.stringify(mockData))
      jsonObj.taskName = item.label
      jsonObj.taskValue = item.value
      return jsonObj
    })

    this.state = {
      showAssign: false,
      assignIndex: -1,
      data: [],
      loading: false,
      workData: null,
      remarkChanged: false,
      showPerson: false
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    //this.loadData("SR304.0684/2560", null)
    $('body').on('click', ()=> { 
      if ($('.Select').hasClass('is-open'))
        $('.table-responsive').css( "overflow-x", "initial" );
      else
        $('.table-responsive').css( "overflow-x", "auto" );
    });
  }

  loadData(workNo,workData,workState) {
    let { data } = this.state
    let that = this
    
    const newInitData = workState.map((item, index) => {
      let jsonObj = JSON.parse(JSON.stringify(mockData))
      jsonObj.taskName = item.label
      jsonObj.taskValue = item.value
      return jsonObj
    })
    

    this.refs.jcbTable.getWrappedInstance().loadData([workData],workState)

    this.setState({ workNo: workNo, loading: true, workData: workData ,data:newInitData})
    WorkdocStore.loadWorkdocOfficeTaskList(workNo, function (result) {

      data = workState.map((titem, index) => {
        let item = JSON.parse(JSON.stringify(mockData))
        item.taskName = titem.label
        item.taskValue = titem.value
        result.data.every(function (ritem, rindex) {
          let tasklist = ritem.tasklist[0]
          if (item.taskValue === tasklist.taskValue) {
            item.bf_task_id = ritem.bf_task_id
            item.taskStatus = tasklist.taskStatus
            item.technicianName = ritem.first_name + ' ' + ritem.last_name
            if (ritem.leader_first_name !== "" && ritem.leader_first_name !== undefined && ritem.leader_first_name !== null)
              item.inspector = ritem.leader_first_name + ' ' + ritem.leader_last_name

            //item.startTime.date = '11/12/2560'
            item.startTime.date = momentHelper.convertWorldToThaiYear(tasklist.startDate)
            item.finishTime.date = momentHelper.convertWorldToThaiYear(tasklist.endDate)
            item.startTime.time = tasklist.startTime !== undefined ? tasklist.startTime : ''
            item.finishTime.time = tasklist.endTime !== undefined ? tasklist.endTime : ''
            item.ackTime = ritem.taskacked_date
            item.duration = tasklist.duration
            item.expectDuration = ritem.expect_duration            

            item.remark = ritem.remark
            item.assignTask.person = { contractor_id: ritem.contractor_id, employee_id: ritem.employee_id, first_name: ritem.first_name, nick_name: ritem.nick_name, last_name: ritem.last_name }
            if (ritem.leader_first_name !== "")
              item.assignTask.leader = { employee_id: ritem.leader_id, first_name: ritem.leader_first_name, nick_name: ritem.leader_nick_name, last_name: ritem.leader_last_name }
            return false
          }
          return true
        })
        return item
      })
      that.setState({ data: data, loading: false })
      // that.setState({data:data})
    }, function () {
      that.setState({ loading: false })
    })
  }

  onPrintClick() {
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintWorkOfficeJobTimeTable&wo='+this.state.workNo
    } else {
      url = './pdf/v2?startPage=PrintWorkOfficeJobTimeTable&wo='+this.state.workNo
    }  
    this.refs.iframePrint.loadUrl(url)
  }

  renderHeader() {
    if (typeof this.state.data === 'undefined') return null
    const ths = Object.keys(this.headerTitles).map((k, i) => (
      <th
        key={i + 1}
        className='fit text-center'
      >
        {this.headerTitles[k]}
      </th>
    ))

    return (
      <thead>
        <tr>{ths}</tr>
      </thead>
    )
  }

  onDateChange(k, rowIndex, dateString, dateMoment) {
    const newData = [...this.state.data]
    newData[rowIndex][k].date = dateString


    //Calculate Duration
    newData[rowIndex] = this.calculateDuration(newData[rowIndex])
    this.setState({
      data: newData
    })

    this.saveTask(rowIndex, newData)
  }

  calculateDuration(itemData) {

    let finishTime = moment(itemData.finishTime.date, 'DD/MM/YYYY')
    let duration = moment.duration(finishTime.diff(moment(itemData.startTime.date, 'DD/MM/YYYY')));

    itemData.duration = duration.asDays() + 1;
    return itemData
  }

  renderDatePicker(rowIndex, value, k) {
    let {editMode} = this.props
    return (
      <DatePicker 
        style={{ display: 'inline-block', minWidth: '160px' }}
        showIcon={true}
        showFooter={true}
        buddhistEra
        value={value}
        onChange={this.onDateChange.bind(this, k, rowIndex)}
        disabled={editMode?false:true}
      />
    )
  }

  onTimeChange(k, index, newValStr) {
    const newData = [...this.state.data]
    newData[index][k].time = newValStr
    this.setState({
      data: newData
    })

    this.saveTask(index, newData)
  }

  onTechnicianEdit(rowId) {
    let { data } = this.state
    // this.setState({ showAssign: true, assignIndex: rowId })
    // this.refs.taskModal.loadTask({}, Object.assign({ bf_task_id: data[rowId].bf_task_id }, data[rowId].assignTask))
    this.setState({showPerson:true,assignIndex:rowId})
  }

  onEmployeeSelect(item){
    this.setState({person:item})
    let {assignIndex,data} = this.state
    let postData = {bf_task_id:data[assignIndex].bf_task_id,person:item,leader:{},totalCost:'0',data:data}
    this.onAssignTaskSave(postData)
  }

  onRowRemarkEdit(rowId){
    let { data } = this.state
    
    this.refs.rowRemarkModal.loadInfo({title:'แก้ไขหมายเหตุ',showClear:true,rowId:rowId, value:data[rowId].remark })    
  }

  onRowRemarkSave(dataValue){
    let {data} = this.state
    let assignIndex = dataValue.rowId
    data[assignIndex].remark = dataValue.value

    this.setState({ data: data })
    this.saveTask(assignIndex, data)
  }

  onSelectChange(rowId, value) {
    let { data } = this.state
    data[rowId].taskStatus = value.value
    this.setState({ data: data })
    this.saveTask(rowId, data)
  }

  onAssignTaskSave(jobData) {
    let { assignIndex, data } = this.state
    data[assignIndex].assignTask = jobData
    data[assignIndex].technicianName = jobData.person.first_name + ' ' + jobData.person.last_name
    if (jobData.leader !== undefined && jobData.leader !== null)
      data[assignIndex].inspector = jobData.leader.first_name + ' ' + jobData.leader.last_name
    else
      data[assignIndex].inspector = null
    data[assignIndex].wageAmount = jobData.totalCost

    this.setState({ data: data, assignIndex: -1 })


    this.saveTask(assignIndex, data)
  }


  onAssignTaskDelete(jobData) {
    let { assignIndex, data } = this.state
    let that = this
    WorkdocStore.delWorkdocFixingTask(jobData.bf_task_id, function () {
      data.splice(assignIndex, 1)
      that.setState({ data: data, assignIndex: -1 })
    }, function () {

    })
  }

  onRemarkChange(e) {
    let { workData } = this.state
    workData.textState = e.target.value
    this.setState({ workData: workData, remarkChanged: true })
  }


  onRemarkBlur() {

  }

  onRemarkSave() {
    let { remarkChanged, workNo, workData } = this.state
    this.saveWorkdocSummary(workNo, workData.textState)
  }

  saveWorkdocSummary(workNo, textState) {
    //Save
    let that = this
    let postData = { wo: workNo, textState: textState }
    WorkdocStore.saveWorkdocSummary(postData, function (result) {


      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดในใบงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc'
      });

    }, function () {
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'บันทึกรายละเอียดในใบงานซ่อม ' + workNo + ' ไม่สำเร็จ',
        level: 'error',
        position: 'tc'
      });
    })


    this.setState({ remarkChanged: false })
  }

  onRemarkClear() {
    let { workData, workNo } = this.state
    workData.textState = ''
    this.setState({ workData: workData })

    this.saveWorkdocSummary(workNo, '')
  }

  onAfterSave(result,data,assignIndex) {
    let { workNo } = this.state
    data[assignIndex].bf_task_id = result.bf_task_id
      this.setState({ data: data })
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกใบงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc'
    });
    if (this.props.onStateChange !== undefined)
      this.props.onStateChange(workNo, result.taskstate)
  }

  updateWorkData(data,rowId) {
    let {workData} = this.state
    let {workState} = this.props
    workData[data[rowId].taskValue] = data[rowId].taskStatus
    this.setState({workData:workData})
    this.refs.jcbTable.getWrappedInstance().loadData([workData],workState)
  }

  saveTask(assignIndex, data) {
    let assignData = data[assignIndex]
    let { workNo } = this.state

    let startDate = assignData.startTime.date !== '' ? momentHelper.convertThaiToWorldYear(assignData.startTime.date) : ''
    let endDate = assignData.finishTime.date !== '' ? momentHelper.convertThaiToWorldYear(assignData.finishTime.date) : ''

    let meta = {
      work_no: workNo,
      contractor_id: assignData.assignTask.person.contractor_id !== undefined ? assignData.assignTask.person.contractor_id : '',
      employee_id: assignData.assignTask.person.employee_id !== undefined ? assignData.assignTask.person.employee_id : "",
      leader_id: assignData.assignTask.leader.employee_id !== undefined ? assignData.assignTask.leader.employee_id : "",
      total_cost: assignData.wageAmount != undefined ? assignData.wageAmount : '0', 
      bf_work_damage_id: 0,
      remark:assignData.remark
    }
    let tasklist = [{
      taskName: assignData.taskName, taskValue: assignData.taskValue, taskStatus: assignData.taskStatus,
      startDate: startDate, startTime: assignData.startTime.time,
      endDate: endDate, endTime: assignData.finishTime.time, duration: assignData.duration
    }]
    let postData = { meta: meta, tasklist: tasklist }
    WorkdocStore.saveWorkdocOfficeTask(assignData.bf_task_id, postData,(result)=>{
        this.updateWorkData(data,assignIndex)
        this.onAfterSave(result,data,assignIndex)
    },()=>{
        this._notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'บันทึกรายละเอียดในใบงานซ่อม ' + workNo + ' ไม่สำเร็จ',
          level: 'error',
          position: 'tc'
        });
    })  
  }

  getStatusOption() {
    let list = [{ label: 'ยังไม่ได้กำหนด', value: '-1' }]

    for (const key in this.props.jobState) {
      let item = this.props.jobState[key]
      let style = this.props.jobStyle[key]
      const label0 = (<div><FontAwesome name='check-circle' style={{color:style.color}} /> {item}</div>)
      list.push(
        { label: label0, value: key }
      )
    }
    return list;
    // const label0 = (<div><FontAwesome name='check-circle' style={{color:'orange'}} /> กำลังทำงาน</div>)
    // const label1 = (<div><FontAwesome name='check-circle' style={{color:'blue'}} /> <span className='text' style={{color:'#fff'}}>ทำงานเสร็จ</span></div>)
    // const label2 = (<div><FontAwesome name='check-circle' style={{color:'red'}} /> เลยกำหนดเวลา</div>)
    // const label3 = (<div><FontAwesome name='check-circle' style={{color:'pink'}} /> งานแก้ไข</div>)
    // return [
    //   { label: 'ไม่มีรายการนี้', value: '-1' },
    //   { label: label0, value: '0' },
    //   { label: label1, value: '1' },
    //   { label: label2, value: '2' },
    //   { label: label3, value: '3' }
    // ]
  }

  renderTimePicker(rowIndex, value, k, titleId) {
    // return (
    //   <TimePicker
    //     key={rowIndex * 100 + index}
    //     value={moment(value, 'HH:mm')}
    //     showSecond={false}
    //     minuteStep={15}
    //     onChange={this.onTimeChange.bind(this, k, index)}
    //   />
    // )
    let {editMode} = this.props
    return (
      <CkTimePicker
        value={value}
        onTimeSaved={this.onTimeChange.bind(this, k, rowIndex)}
        disabled={editMode?false:true}
      />
    )
  }

  renderDateTimeTD(rowIndex, item, k, titleId) {
    if (k === 'startTime') {

      return (
        <td
          key={titleId}
          style={{ padding: '0' }}>
          <div style={{ display: 'table-row' }} >
            <div className='bt-td-left'>
              {'วันที่'}
            </div>
            <div className='bt-td-right text-center' style={{ width: '100%' }}>
              {/* 'item.startTime.date' */}
              {this.renderDatePicker(rowIndex, item.startTime.date, k)}
            </div>
          </div>
          <div style={{ display: 'table-row' }} >
            <div
              className='bt-td-left'
              style={{ borderBottom: '0' }}
            >
              {'เวลา'}
            </div>
            <div
              className='bt-td-right text-center'
              style={{ width: '100%', borderBottom: '0' }}>
              {this.renderTimePicker(rowIndex, item.startTime.time, k, titleId)}
            </div>
          </div>
        </td>
      )
    }
    return (
      <td
        key={titleId}
        style={{ padding: '0' }}
      >
        <div style={{ display: 'table-row' }} >
          <div className='bt-td-right text-center' style={{ width: '1%' }}>
            {this.renderDatePicker(rowIndex, item.finishTime.date, k)}
          </div>
        </div>
        <div style={{ display: 'table-row' }} >
          <div
            className='bt-td-right text-center'
            style={{ width: '1%', borderBottom: '0' }}>
            {this.renderTimePicker(rowIndex, item.finishTime.time, k, titleId)}
          </div>
        </div>
      </td>
    )
  }

  renderNormalTD(rid, item, k, titleId) {
    return (
      <td key={titleId} className='fit text-center'>
        {item[k]}
      </td>
    )
  }

  renderButtonTD(rid, item, k, titleId, titleBtn) {
    let {editMode} = this.props
    if (item[k] !== undefined && item[k] !== "" && item[k] !== "0") {
      titleBtn = item[k]==' '?'(ไม่ระบุชื่อ)':item[k]
    }
    return (
      <td key={titleId} className={'fit text-center'}><Button disabled={editMode?false:true} bsStyle='link' onClick={this.onTechnicianEdit.bind(this, rid)}>
        <FontAwesome name='pencil' />{' '} {titleBtn}</Button></td>
    )
  }

  renderRemarkTD(rid, item, k, titleId, titleBtn) {
    let {editMode} = this.props
    if (item[k] !== undefined && item[k] !== "" && item[k] !== "0") {
      titleBtn = item[k]
    }
    return (
      <td key={titleId} className='fit text-center'><Button disabled={editMode?false:true} bsStyle='link' onClick={this.onRowRemarkEdit.bind(this, rid)}>
        <FontAwesome name='pencil' />{' '} {titleBtn}</Button></td>
    )
  }

  renderStatus(rid, item, k, titleId) {
    // let bgColor = '';

    // if (item[k]=='0') {
    //   bgColor = 'orange'
    // }else if (item[k] == '2') {
    //   bgColor = 'blue'
    // } else if (item[k] == '3') {
    //   bgColor = 'red'
    // } else if (item[k] == '4') {
    //   bgColor = 'pink'
    // }


    
    let {editMode,jobStyle} = this.props
    let bgColor = (item[k] in jobStyle)?jobStyle[item[k]]:''
    return (
      <td key={titleId} className='fit text-center'>
        <Select 
          placeholder='เลือก...' clearable={false}
          style={{ minWidth: '90px', background: bgColor }}
          value={item[k]}
          options={this.getStatusOption()}
          onChange={this.onSelectChange.bind(this, rid)}
          disabled={editMode?false:true}
        />
      </td>
    )
  }

  renderRowBg(taskStatus) {
    if (taskStatus === '4') {
      return 'bg-gray-light'
    } else {
      return ''
    }
  }

  minuteToString(seconds){
    var value = seconds;

    var units = {
        "วัน": 24*60,
        "ชั่วโมง": 60,
        "นาที": 1        
    }

    var result = []

    for(var name in units) {
      var p =  Math.floor(value/units[name]);
      if(p == 1) result.push(" " + p + " " + name);
      
      value %= units[name]
    }

    return result;

  }

  renderDuration(rid, item, k, titleId) {
    let textTD = ''
    if (item[k] !== '' && item[k] > 0)
        textTD = item[k] + ' วัน'
      
    else {
      textTD = 'ไม่ระบุ'
    }
    return (<td key={titleId} className='fit text-center'>{textTD}</td>)
  }

  renderRows() {
    if (this.state.data.length === 0) return null
    return this.state.data.map((item, rid) => {
      const tds =
        Object.keys(this.headerTitles).map((k, titleId) =>
          (
            ['startTime', 'finishTime'].includes(k)
              ? this.renderDateTimeTD(rid, item, k, titleId)
              : (k == 'technicianName')
                ? this.renderButtonTD(rid, item, k, titleId, 'แก้ไขชื่อพนักงาน')
                : (k == 'wageAmount')
                  ? this.renderButtonTD(rid, item, k, titleId, 'แก้ไขราคา')
                  : (k == 'inspector')
                    ? this.renderButtonTD(rid, item, k, titleId, 'แก้ไขผู้ตรวจสอบ')
                    : (k == 'remark')
                    ? this.renderRemarkTD(rid, item, k, titleId, 'แก้ไขหมายเหตุ')
                    : (k == 'taskStatus')
                      ? this.renderStatus(rid, item, k, titleId)
                      : (k == 'duration')
                        ? this.renderDuration(rid, item, k, titleId)
                        : this.renderNormalTD(rid, item, k, titleId)
          ))

      return (
        <tr key={rid} className={this.renderRowBg(item.taskStatus)}>{tds}</tr>
      )
    })
  }

  renderTable() {
    let { workData } = this.state
    let {editMode} = this.props
    return (
      <div>
        <div className='table-responsive'>
          <table className='table table-responsive table-hover table-bordered-solid'>
            {this.renderHeader()}
            <tbody>
              {this.renderRows()}
            </tbody>
          </table>
        </div>
        <Row>
          <Col md={6}>
            <FormGroup
              controlId="formBasicText"
            >
              <ControlLabel>** หมายเหตุ</ControlLabel>
              <FormControl
                componentClass="textarea"
                placeholder=""
                value={
                  workData !== null
                    ? workData.textState
                    : ''}
                onChange={this.onRemarkChange.bind(this)}
                onBlur={this.onRemarkBlur.bind(this)}
                disabled={editMode?false:true}
              />
              <FormControl.Feedback />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ButtonToolbar>
              <Button disabled={editMode?false:true} bsStyle='primary' onClick={this.onRemarkSave.bind(this)}><FontAwesome name='save' />{' '}บันทึกหมายเหตุ</Button>
              <Button disabled={editMode?false:true} onClick={this.onRemarkClear.bind(this)}><FontAwesome name='eraser' />{' '} ลบทิ้ง</Button>
            </ButtonToolbar>
          </Col>
        </Row>
      </div>
    )
  }

  render() {
    let titleTask = ''
    let { showAssign, loading } = this.state
    return (
      <Box loading={loading}>
        <Box.Header  className='text-center'>
          <Box.Title>
                          
          </Box.Title> 
          <Box.Tools>
            <Button className="btn bg-maroon" onClick={this.onPrintClick.bind(this)}>
              <FontAwesome name="print" />&nbsp;พิมพ์เอกสาร
            </Button>
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          <JobControlBoardTable ref='jcbTable' 
          showSearch={false}
          jobStyle={this.props.jobStyle}
          jobState={this.props.jobState}
          />
          {this.renderTable()}

          <WorkJobAssignTaskModal ref='taskModal' show={showAssign} title={titleTask}
            showTask={false}
            showLeader={true}
            onDelete={this.onAssignTaskDelete.bind(this)}
            onSave={this.onAssignTaskSave.bind(this)}
            onHide={() => { this.setState({ showAssign: false }) }} />
          <TextFieldModal ref='rowRemarkModal' 
          confirmTitle='บันทึก'
          onConfirm={this.onRowRemarkSave.bind(this)}
          />
          <NotificationSystem ref="notificationSystem" />
        </Box.Body>
        <Box.Footer>

        </Box.Footer>
        <IframeModal ref='iframePrint' title='พิมพ์เอกสาร'/>
        <EmployeeModal 
          show={this.state.showPerson} 
          onSelect={this.onEmployeeSelect.bind(this)} 
          onHide={()=>{this.setState({showPerson:false})}}
        />
      </Box>
    )
  }
}

RecheckTimeTable.defaultProps = {
  editMode: true
}


// WEBPACK FOOTER //
// ./src/view/workdoc/recheckcontrol/RecheckTimeTable.js